/* global localStorage */
export class LocalStorageService {
  public static set(key: string, value: any): void {
    try {
      const serializedValue = JSON.stringify(value)
      localStorage.setItem(key, serializedValue)
    } catch (error) {
      console.error('Error saving to localStorage:', error)
    }
  }

  public static get(key: string): any {
    try {
      const serializedValue = localStorage.getItem(key)

      return serializedValue ? JSON.parse(serializedValue) : null
    } catch (error) {
      console.error('Error reading from localStorage:', error)

      return null
    }
  }

  public static remove(key: string): void {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error('Error removing from localStorage:', error)
    }
  }
}
